import FetchSuccess from "lib/utils/FetchSuccess";
import { getEnvs } from "state/EnvironmentsContext/EnvContext";

type FeatureFlagsApiResponse = {
  data: {
    management_dashboard_feature_flags: Array<{
      key: string;
      id: string;
      enabled: boolean;
    }>;
  };
};

export const getFeatureFlags = async (): Promise<FeatureFlagsApiResponse> => {
  const { urlMap } = getEnvs((state) => state);

  const response = await fetch(
    `${urlMap.v3}management-dashboard/feature-flags`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    },
  );

  return new FetchSuccess(response);
};
